<template>
  <modal
    class="meetings"
    :class="$style.meetings"
    :header-text="$t('settings.meetingsAndConferences')"
    hide-footer="true"
    @close="close()"
  >
    <template #header>
      <store-based-date-time-picker :clearable="false" @update="updateData" />
      <button :class="$style.button" @click="toggleAddMeetings">
        {{ $t('global.add') }}
      </button>
    </template>
    <div :class="$style.container">
      <Loader v-if="isPending" />
      <v-table v-else :data="tableData" :columns="columns" clickable @row-click="toggleAddMeetings">
        <template v-slot:column-date="item">
          {{ item.row.date | formatDate }}
        </template>
        <template v-slot:column-name="item">
          {{ getMeetingName(item.row) }}
        </template>
      </v-table>
    </div>

    <add-meetings-modal
      v-if="isOpenAddMeetings"
      :meeting="currentMeeting"
      :types="types"
      @close="toggleAddMeetings"
      @update="fetch"
      @updateType="fetchType"
    />
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/settings-modal.vue';
import StoreBasedDateTimePicker from '@/components/common/filter/store-based-date-time-picker.vue';
import Loader from '@/components/common/blocks/loader.vue';
import VTable from '@/components/common/table/table.vue';
import { getMeetings, getMeetingsTypes } from '@/api/methods/settings';
import { formatDate } from '@/helpers/format-date';
import addMeetingsModal from './add-meetings-modal.vue';

export default {
  components: { Modal, StoreBasedDateTimePicker, Loader, VTable, addMeetingsModal },
  filters: {
    formatDate,
  },
  data() {
    return {
      isPending: false,
      types: [],
      tableData: [],
      isOpenAddMeetings: false,
      currentMeeting: null,
      columns: [
        {
          field: 'name',
          title: this.$t('settings.columns.typeOfMeeting'),
          width: 20,
        },

        { field: 'caption', title: this.$t('settings.columns.comment'), width: 50 },
        {
          field: 'date',
          title: this.$t('settings.columns.date'),
          width: 10,
          center: true,
          sorted: true,
          sortFn: (isAsc) => (a, b) => (new Date(a.date) - new Date(b.date)) * (isAsc ? 1 : -1),
        },

        { field: 'time', title: this.$t('settings.columns.time'), width: 20, center: true },
      ],
    };
  },
  computed: {
    dateRange() {
      return this.$store.getters['filters/formattedDateRange'];
    },
  },
  async created() {
    const { dateFrom: dateFromQuery, dateTo: dateToQuery } = this.$route.query;
    if (!dateFromQuery || !dateToQuery) {
      const [dateFrom, dateTo] = this.$store.getters['filters/dateRange'];
      this.$router.replace({
        query: {
          ...this.$route.query,
          dateFrom,
          dateTo,
        },
      });
    }
    this.isPending = true;
    await this.updateData();
    await this.fetchType();
    this.isPending = false;
  },
  destroyed() {
    this.$router.replace({ query: null });
  },
  methods: {
    close() {
      this.$emit('close');
    },
    toggleAddMeetings(meetingId = null) {
      if (meetingId) this.currentMeeting = this.tableData.find(({ id }) => id === meetingId);
      this.isOpenAddMeetings = !this.isOpenAddMeetings;
    },
    getMeetingName({ type, name }) {
      const currentKey = `settings.meetings.${type}`;
      return this.$te(currentKey) ? this.$t(currentKey) : name || '';
    },
    async updateData() {
      this.isPending = true;

      const { dateFrom, dateTo } = this.$route.query;
      this.$store.commit('filters/updateDateRange', [dateFrom, dateTo]);
      await this.fetch();

      this.isPending = false;
    },

    async fetch() {
      const compId = this.$route.params.computer;
      const { data } = await getMeetings(compId, this.dateRange.dateFrom, this.dateRange.dateTo);
      if (data.success) this.tableData = data.result;
    },

    async fetchType() {
      const { data } = await getMeetingsTypes();
      if (data.length) this.types = data;
    },
  },
};
</script>

<style>
  .meetings .settings-modal_modal_3LaCC {
    width: 50%;
  }
  .meetings .settings-modal_headerText_XT_QT {
    margin: 0;
  }
</style>
<style lang="scss" module>
  .meetings {
    z-index: 1;
  }
  .button {
    cursor: pointer;
    width: 90px;
    background: #2985bf;
    border: none;
    border-radius: 2px;
    font: inherit;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    opacity: 1;
    height: 34px;
    margin: auto 0 0;
  }
  .button:hover {
    opacity: 0.8;
  }
  .button:active {
    background: rgb(73, 173, 106);
  }

  .container {
    height: 400px;
    overflow-y: auto;
  }
</style>
